import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import NavDrawer from '../mentorComponents/navDrawer/NavDrawer';
import RateReviewIcon from '@mui/icons-material/RateReview';
import AssessmentIcon from '@mui/icons-material/Assessment';

function ReportViewerDashboard() {
  const { coeName } = useParams();
  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  });

  const basePath = React.useMemo(() => {
    if (coeName) return `/${coeName}`;
    const userCoe = user?.coeName || user?.coe_name;
    const formattedCoeName = userCoe ? userCoe.trim().replace(/\s+/g, '-') : 'coe';
    return `/${formattedCoeName}`;
  }, [coeName, user]);

  const menuItems = React.useMemo(() => [
    { label: 'Learner Reviews', icon: <RateReviewIcon />, path: `${basePath}/learner-reviews` },
    { label: 'Learner Attendance', icon: <AssessmentIcon />, path: `${basePath}/learner-attendance` }
  ], [basePath]);

  return (
    <div>
      <NavDrawer menuItems={menuItems} mobileViewMenuItems={menuItems} />
    </div>
  );
}

export default ReportViewerDashboard;
